import { Asset, AssetLayout } from '../'
import { AssetId } from '../../model'

export const getPostCheckoutLayout = (id: AssetId): AssetLayout => {
  switch (id) {
    case AssetId.GiftCard202306:
      return Asset.GiftCard
    case AssetId.MarketingOptIn202308:
      return Asset.MarketingOptIn
    case AssetId.CashAppOrderServicingMessage202503:
      return Asset.CashAppServicingMessage
    default:
      return Asset.Survey
  }
}
